import type { RowData, TableOptions } from '@tanstack/react-table';

import type { DataTableLineWrapProps } from './line-wrap-types.js';
import { useControllableState } from '../../../../core/hooks/useControllableState.js';
import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import type { TDataTableFeatures } from '../types/features.types.js';

/**
 * Configuration hook for the DataTable LineWrap feature.
 * @internal
 */
export function useColumnLineWrap<TData extends RowData>(
  props: DataTableLineWrapProps,
  options: TableOptions<TDataTableFeatures, TData>,
): void {
  const configLineWrap = useDataTableConfigElement('lineWrap');

  const [columnLineWrap, onColumnLineWrapChange] = useControllableState({
    value: props.lineWrap ?? configLineWrap,
    defaultValue: props.defaultLineWrap,
    onChange: props.onLineWrapChange,
  });

  // eslint-disable-next-line react-hooks/immutability
  options.state = {
    ...options.state,
    columnLineWrap,
  };
  // eslint-disable-next-line react-hooks/immutability
  options.onColumnLineWrapChange = onColumnLineWrapChange;
}
